// Import all storage implementations
import * as supabaseStorage from './storage';
import * as supabaseS3Storage from './supabase-s3-storage';

// Flag to determine which storage to use
// Now using Supabase Storage via S3 API for better user-specific access control
const useSupabaseS3Storage = true; // Set to true to use Supabase Storage via S3 API

// Create a unified interface that works with any storage backend
export const storage = useSupabaseS3Storage 
  ? supabaseS3Storage 
  : supabaseStorage;

// Export individual functions for more direct access
export const { 
  uploadFile, 
  uploadSitePhoto, 
  getProjectImages, 
  uploadDocument, 
  uploadProfileAvatar,
  deleteFile
} = storage;

// Helper to determine which storage backend is in use
export function getStorageBackendName(): string {
  if (useSupabaseS3Storage) {
    return 'Storage';
  } else {
    return 'Storage';
  }
} 